import Table from './components/Table/Table';
import { Route, Routes } from 'react-router-dom';
import Home from './components/Home/Home';
import Header from './components/Header/Header';
import './App.css';

function App() {
  return (
    <div className="App">
      <Header />
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route path="/recently-deployed-tokens" element={<Table />} />
      </Routes>
    </div>
  );
}

export default App;
